import { VStack, Text, Button } from '@chakra-ui/react';

import StoreItems from '~/components/StoreItems';

import * as fp from 'lodash/fp';

import useCartOrders from '~/hooks/useCartOrders';
import useCartId from '~/hooks/useCartId';

import { useNavigate, useParams } from 'react-router-dom';

import { CartType, StoreOrderInCart } from '~/types/cart';
import getPath from '~/utils/getNavigatePath';

type StoreItemsListProps = {
  orders: Array<StoreOrderInCart>;
  invalidStoreIds: Array<string>;
};

export default function StoreItemsList({ orders, invalidStoreIds }: StoreItemsListProps) {
  const navigate = useNavigate();
  const { groupId = '', enterpriseGroupBuyId = '' } = useParams();
  const { handleDeleteItem } = useCartOrders();

  const { cartType } = useCartId();

  const handleEditNavigate = (storeId: string, itemId: string, keyId: string) => {
    navigate(
      getPath(`/store/${storeId}/item/${itemId}/edit/${keyId}`, groupId, enterpriseGroupBuyId),
      { state: { previous: window.location.pathname } },
    );
  };

  const handleStoreNavigate = (storeId: string) => {
    navigate(getPath(`/store/${storeId}`, groupId, enterpriseGroupBuyId), {
      state: { previous: window.location.pathname },
    });
  };

  const handleHomeNavigate = () => {
    navigate(getPath('', groupId, enterpriseGroupBuyId), {
      state: { previous: window.location.pathname },
    });
  };

  if (fp.eq(orders.length, 0)) {
    return (
      <VStack align="stretch" p={2} bgColor="gray.100">
        <Text my={5} fontWeight="bold" textAlign="center">
          目前無餐點，快來點餐
        </Text>
        <Button
          size="sm"
          isFullWidth
          bgColor="primaryLight"
          color="fontColor"
          onClick={handleHomeNavigate}
          _hover={{ bgColor: 'primaryLight', color: 'fontColor' }}
          _active={{ bgColor: 'primaryLight', color: 'fontColor', opacity: 0.8 }}
        >
          去點餐
        </Button>
      </VStack>
    );
  }

  return (
    <VStack align="stretch" spacing={4}>
      {orders.map((order) => (
        <StoreItems
          key={order.storeId}
          order={order}
          allowEdit={true}
          cartType={cartType}
          isInvalid={invalidStoreIds.includes(order.storeId)}
          onEdit={handleEditNavigate}
          onDelete={handleDeleteItem}
          onStoreDetail={!!enterpriseGroupBuyId ? undefined : handleStoreNavigate}
        />
      ))}
    </VStack>
  );
}
